import { render, staticRenderFns } from "./jgItem.vue?vue&type=template&id=2cb9e481&scoped=true"
import script from "./jgItem.vue?vue&type=script&lang=js"
export * from "./jgItem.vue?vue&type=script&lang=js"
import style0 from "./jgItem.vue?vue&type=style&index=0&id=2cb9e481&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9e481",
  null
  
)

export default component.exports